<template>
	<transition name="el-fade-in-linear">
    <div v-show="transitionshow">      

   		<!------------------------Order search start (提成搜索开始)---------------------->
		<el-form :inline="true" class="backborder1 demo-form-inline" size="small" filterable clearable>			
			<el-form-item style="width:20%">
				<el-date-picker	v-model="query.date" type="daterange" style="width:100%"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format="yyyy-MM-dd" :unlink-panels="false" @change="ischange=true">
				</el-date-picker>
			</el-form-item>
			<el-form-item style="width:10%">
				<el-select v-model="query.order_type" placeholder="订单状态" @change="ischange=true">
					<el-option v-for="(item,index) in ordertypelists" :label="item.name" :value="item.id" :key="index"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item ref="query.key" :model="query">
				<el-input placeholder="订单编号 / 收货人名称 / 收货人电话" v-model="query.key" clearable @change="ischange=true" style="width:100%"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="searchorder">查询</el-button>
				<el-button size="small" type="primary" icon="el-icon-search" @click="checkinventory">查看库存</el-button>
				<el-tooltip class="item" effect="dark" content="快递鸟打印快递电子面单" placement="top-start" v-if="$cookies.get('agentid')==36 || $cookies.get('agentid')==1 || $cookies.get('agentid')==7">
					<el-button type="warning" size="small" icon="el-icon-printer" circle @click="shippingbirldprint"></el-button>
				</el-tooltip>
			</el-form-item>
		</el-form>
		<!------------------------Order search end (提成搜索结束)------------------------>

		<!--- 信息提示 -->
		<div style="margin-top:10px;border-radius:5px;padding:.3rem 1% .3rem 1%;background:rgb(211,211,211,.6)">
			<span style="font-size:.7rem;color:red">温馨提示：此功能仅为仓库小伙伴对有贝商品的发货提供便利服务。订单中的商品非宠赞商品，数据统计也不纳入宠赞系统。如需查看具体数据，请移步有贝系统</span>
		</div>

		<!------------------------Order lists start (提成列表结束)------------------------>
		<div class="backborder2" style="margin-top:10px">
			<el-table :data="orderlists" style="width:100%" v-loading="orderLoading">
				<el-table-column type="expand">
				<template slot-scope="props">
				    <div style="float:left;width:100%;padding:15px 0 15px 1%;background:#fff;border-bottom:1px solid #ebeef5">
				        收货人姓名： {{props.row.address_name}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				        收货人电话： {{props.row.address_phone}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br/>		
						地址信息：{{props.row.address_info}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br/>
						物流单号：{{props.row.order_code}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br/>
			            订单备注：{{props.row.remark}}
			        </div>
	                <el-table :data="props.row.goods">
		                <el-table-column label="商品名称">
		                	<template slot-scope="goods">
								<img :src="goods.row.images" style="float:left;width:8%;border:1px solid rgb(221,221,221,.7);border-radius:5px"/>
								<span style="float:left;width:87%;margin-left:2%;">
									{{goods.row.pro_name}}
								</span>
								<span style="float:left;margin-left:2%;color:rgb(144, 147, 153);font-size:.8rem">规格：{{goods.row.spec}}</span>
							</template>
		                </el-table-column>
		                <el-table-column prop="price" label="单价" width="150" align="center"></el-table-column>
						<el-table-column prop="num" label="数量" width="150" align="center"></el-table-column>
		                <el-table-column prop="allprice" label="小计" width="150" align="center"></el-table-column>
	                </el-table>
	            </template>
				</el-table-column>
				<el-table-column label="订单编号" prop="order_sn" ></el-table-column>
				<el-table-column label="订单金额" prop="order_price" width="150" align="center"></el-table-column>
				<el-table-column label="订单状态" prop="statusname" width="150" align="center"></el-table-column>
				<el-table-column label="下单时间" prop="inputtime" width="180" align="center"></el-table-column>
				<el-table-column label="操作" prop="inputtime" width="100" align="center">
					<template slot-scope="props">
						<el-button v-if="props.row.order_status==2 || props.row.statusname=='待发货'" type="success" size="mini" icon="el-icon-check" circle @click="ordersend(props.row.id)"></el-button>
						<el-button v-if="props.row.statusname=='待收货' || props.row.statusname=='交易成功' " type="warning" size="mini" icon="el-icon-setting" circle @click="setshippingcode(props.row.id)"></el-button>
						<el-tooltip class="item" effect="dark" content="订单信息打印电子面单" placement="top" v-if="$cookies.get('agentid')==36 || $cookies.get('agentid')==1">
							<el-button type="warning" size="mini" icon="el-icon-printer" circle @click="shippingbirldsingleprint(props.row)"></el-button>
						</el-tooltip>
					</template>
				</el-table-column>
				
			</el-table>
			<div class="block">
		        <el-pagination 
		            @size-change="orderpageSizeChange" 
		          	@current-change="orderpageCurrentChange"
		          	:current-page="query.p"
		          	:page-sizes="[10, 20, 50]"
		          	:page-size="query.rollpage"
		          	layout="total, sizes, prev, pager, next, jumper"
		          	:total="total_rows">
		        </el-pagination>
	   		</div>
		</div>
		
		<el-dialog title="填写物流单号" :visible.sync="shippingDialog" width="20%" top="20vh">
            <el-input placeholder="物流单号" v-model="shippingcode" clearable style="width:100%"></el-input>	
        	<div slot="footer" class="dialog-footer">
		    	<el-button size="small" @click="shippingDialog = false">取 消</el-button>
		        <el-button size="small" type="primary" @click="saveshipping">确认</el-button>
		    </div>
        </el-dialog>

		<el-dialog title="商品库存查询" :visible.sync="inventoryDialog" width="60%" top="10vh">
			<el-form :inline="true" size="small" filterable clearable>			
				<el-form-item>
					<el-input placeholder="商品名称 / 商品条形码" v-model="inventoryquery.key" clearable @change="inventorychange=true" @input="getinventorys" @keyup.enter.native="getinventorys" style="width:100%"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" icon="el-icon-search" @click="getinventorys">查询</el-button>
				</el-form-item>
			</el-form>
			<el-table :data="inventorylists" style="width:100%" v-loading="inventoryLoading">
				<el-table-column label="商品信息">
					<template slot-scope="props">
						<span style="float:left;width:100%">{{props.row.productname}}</span>
						<span style="float:left;width:100%;color:rgb(144, 147, 153);font-size:.8rem">规格：{{props.row.spec}}</span>
					</template>
				</el-table-column>
				<el-table-column label="条形码" prop="barcode" width="180" align="left"></el-table-column>
				<el-table-column label="剩余库存" prop="showinventory" width="150" align="center"></el-table-column>				
			</el-table>
			<div class="block">
		        <el-pagination 
		            @size-change="inventorypageSizeChange" 
		          	@current-change="inventorypageCurrentChange"
		          	:current-page="inventoryquery.p"
		          	:page-sizes="[10, 20, 50]"
		          	:page-size="inventoryquery.rollpage"
		          	layout="total, sizes, prev, pager, next, jumper"
		          	:total="inventory_rows">
		        </el-pagination>
	   		</div>

        	<div slot="footer" class="dialog-footer">
		    	<el-button size="small" @click="inventoryDialog = false">取 消</el-button>
		    </div>
        </el-dialog>
   		
	</div>
	</transition>     
</template>

<script>
export default {
    data () {
        return {
        	actionauth:'', //功能权限
      	    transitionshow:true,
            url: this.GLOBAL.domain+"Yb/index",
        	orderLoading:false,
        	orderlists:[],
        	total_rows:0,
            query: {
                act: 'lists',
                token: this.$cookies.get('token'),
                date: [],
				order_type:1,
				key:'',
                p: 1,
                rollpage: 10
            },
            ordertypelists:[{id:0,name:'待发货'},{id:1,name:'全部'}],
			ischange:false,
			orderLoading:false,
			orderid:'',
			shippingcode:'',
			shippingDialog:false,
			inventoryquery: {
				act:'checkinventory',
				token: this.$cookies.get('token'),
				key:'',
				p:1,
				rollpage:10
			},
			inventory_rows:0,
			inventoryDialog:false,
			inventorylists:[],
			inventorychange:false,
			inventoryLoading:false,
			printloading:'',
        }  
    },
  
    mounted(){
		//获取功能权限
		this.getactionauth();
		this.searchorder();
    },
  
    methods:{

		 //获取功能权限
		getactionauth() {
			var data =this.$cookies.get('actionauth');
		    data=JSON.parse(data);
		    this.actionauth=data;
		},

		/** 搜索订单信息 **/
  	    searchorder() {
		    if(this.ischange==true) {
				this.query.p=1;
				this.query.rollpage=10;
			}

  	        this.orderLoading = true; //开启提成预加载动画
  	        var resource = this.$resource(this.url);
	        resource.query(this.query).then((res) => {
	      		if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login');
		            this.orderLoading = false; //关闭加载动画
		            this.$message.error(res.data.Message);
		        }else{
		            this.orderlists = JSON.parse(Base64.decode(res.data.Data));
		            this.total_rows=parseInt(res.data.count);
		            this.orderLoading = false; //关闭加载动画
					if(this.ischange==true) this.ischange=false;
		        }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
	            this.orderLoading = false; //关闭加载动画
	        });
  	    },
  	    
  	    /** 下一页 **/
  	    orderpageSizeChange(val) {
  	        this.query.rollpage = val;
            this.searchorder();
  	    },
  	    /** 下一页 **/
  	    orderpageCurrentChange(val) {
  	        this.query.p = val;
            this.searchorder();
  	    },

	    /** 发货 **/
		ordersend(id) {
  	        var resource = this.$resource(this.url);
	        resource.query({act:'sendorder',token: this.$cookies.get('token'),id:id}).then((res) => {
	      		if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login');
		            this.$message.error(res.data.Message);
		        }else{
					this.$message.success("发货成功");
		            this.searchorder();
		        }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
	        });
		},

		/** 编辑物流单号 **/
		setshippingcode(id) {
			this.orderid=id;
			this.shippingcode='';
			this.shippingDialog=true;
		},

		saveshipping() {
			var resource = this.$resource(this.url);
	        resource.query({act:'sendorder',token: this.$cookies.get('token'),id:this.orderid,code:this.shippingcode}).then((res) => {
	      		if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login');
		            this.$message.error(res.data.Message);
		        }else{
					this.$message.success("设置物流单号成功");
					this.shippingDialog=false;
		            this.searchorder();
		        }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
	        });
		},

		/** 查看有贝库存 **/
		checkinventory() {
			this.inventoryDialog=true;
			this.inventoryquery.key='';
			this.inventoryquery.p=1;
			this.inventoryquery.rollpage=10;
			this.getinventorys();
		},

		getinventorys() {
			if(this.inventorychange==true) {
				this.inventoryquery.p=1;
				this.inventoryquery.rollpage=10;
			}
			this.inventoryLoading=true;
			var resource = this.$resource(this.url);
	        resource.query(this.inventoryquery).then((res) => {
	      		if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login');
		            this.$message.error(res.data.Message);
					this.inventoryLoading=false;
		        }else{
					this.inventorylists = JSON.parse(Base64.decode(res.data.Data));
		            this.inventory_rows=parseInt(res.data.count);
		            this.inventoryLoading = false; //关闭加载动画
					if(this.inventorychange==true) this.inventorychange=false;
		        }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
				this.inventoryLoading=false;
	        });
		},

		/** 下一页 **/
  	    inventorypageSizeChange(val) {
  	        this.inventoryquery.rollpage = val;
            this.getinventorys();
  	    },
  	    /** 下一页 **/
  	    inventorypageCurrentChange(val) {
  	        this.inventoryquery.p = val;
            this.getinventorys();
  	    },


		/** 打印电子面单 **/
		shippingbirldprint() {
			this.$emit('listenchild',{name:'快递鸟打印电子面单',url:'sellshippingbirld',data:{sellid:0}});
		},


		/** 打印单个电子面单 **/
		shippingbirldsingleprint(item) {
			this.printloading=this.$loading({
				lock: true,
				text: '数据处理中，请稍等片刻...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.8)'
			});	

			//数据移交后台查看当前订单数据是否存在
			this.$emit('listenchild',{name:'快递鸟打印电子面单',url:'sellshippingbirld',data:{sellid:item.id,type:1,documents:item.order_sn}});
			this.printloading.close();
		},

	}
}
</script>


<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.packstyle {float:left;margin-top:10px;background:#fff;border-radius:5px;padding:1rem 2% 1rem 2%;width:96%}
.packstyle li {padding:0 5% 1rem 0;float:left;width:100%;list-style-type:none}
.packstyle .icon {width:1.2rem;height:1.2rem;border-radius:50%;position:absolute;margin-left:-.65rem;margin-top:0}
.packstyle .icon img {width:100%;background:#fff}
.packstyle .time {float:left;margin-left:3%;margin-top:-.1rem;color:#303133;font-size:.7rem;line-height:1.5rem}
.packstyle .content {float:left;width:90%;margin-left:3%;color:#909399;font-size:.7rem;line-height:1.5rem}
</style>



// WEBPACK FOOTER //
// src/components/home/yborder.vue